import create from "zustand";

import pushToAnalytics from "../../../../utils/analytics";
import { roundNumber } from "../../../../utils/NumberHelpers";
import createFormErrorSlices from "../../../../utils/store/tsFormErrors";

interface iLngCalculator {
    tap: "heatingOil" | "gas";
    input: { inputHeatingOil: string; inputGas: string };
    result: number | null;
    setTap: (tap: "heatingOil" | "gas") => void;
    setInput: (input: { inputHeatingOil: string; inputGas: string }) => void;
    calculate: () => void;
    hasError: boolean;
}

const useStore = create<iLngCalculator>((set, get) => ({
    ...createFormErrorSlices(set, get),
    tap: "heatingOil",
    input: {
        inputHeatingOil: "",
        inputGas: "",
    },
    result: null,
    hasError: false,

    calculate: () => {
        set({ hasError: false });
        if (get().tap === "heatingOil") {
            pushToAnalytics("converter-lpg", {
                calculate: "heatingOil",
                amount: get().input.inputHeatingOil,
            });
            const amountHeatingOil = Number(
                get().input.inputHeatingOil.replace(",", ".")
            );
            if (isNaN(amountHeatingOil) || amountHeatingOil < 0) {
                set({ hasError: true });
                return;
            }
            const tempResult = roundNumber(amountHeatingOil / 0.662, 2);
            set({
                result: tempResult,
            });
        }
        if (get().tap === "gas") {
            pushToAnalytics("converter-lpg", {
                calculate: "gas",
                amount: get().input.inputGas,
            });
            const amountGas = Number(get().input.inputGas.replace(",", "."));
            if (isNaN(amountGas) || amountGas < 0) {
                set({ hasError: true });
                return;
            }
            const tempResult = roundNumber(amountGas / 6.57, 2);
            set({
                result: tempResult,
            });
        }
    },

    setTap: (tap) => {
        set({
            tap: tap,
        });
    },

    setInput: (input) => {
        set({
            input: input,
        });
    },
}));

export default useStore;
